import * as React from 'react';
export const IcTutorial = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.76 6.86c-.47.21-.76.68-.76 1.19v9.33c0 .63.67 1.03 1.22.73.97-.53 2.38-1.12 4.06-1.12 1.78 0 2.74.14 4.22 1.06V7.49C10.44 6.43 9.3 5.8 7.51 5.8c-2.03 0-3.78.63-4.75 1.06zM21.24 6.86c-.98-.44-2.73-1.06-4.75-1.06-1.79 0-2.93.64-3.99 1.69v10.56c1.48-.92 2.44-1.06 4.22-1.06 1.68 0 3.09.6 4.06 1.12.55.3 1.22-.1 1.22-.73V8.05c0-.51-.29-.98-.76-1.19z'
      fill='currentColor'
    />
  </svg>
);
